import { render, staticRenderFns } from "./ProjectCustomers.vue?vue&type=template&id=4fdbad1d&scoped=true&"
import script from "./ProjectCustomers.vue?vue&type=script&lang=js&"
export * from "./ProjectCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbad1d",
  null
  
)

export default component.exports